import './insights.scss';
import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useStores } from '../../store';
import { observer } from 'mobx-react-lite';
import { insightsNavigationMenuOptions } from '../protection/navigation-menu-options';
import { NavigationMenu } from '../protection/navigation-menu';
import { MainPages } from '../../../utils/enums';
import { VersionButtonContainer } from '../version-button/version-button-container';

export const Insights: React.FC = observer(() => {
    const { logsStore, unsavedChangesStore, uiStore } = useStores();

    useEffect(() => {
        uiStore.setMainPage(MainPages.INSIGHTS);
    }, []);

    useEffect(() => {
        // the handler for actually showing the prompt
        const handler = (event: BeforeUnloadEvent) => {
            if (unsavedChangesStore.hasUnsavedChanges) {
                event.preventDefault();
            }
        };
        window.addEventListener('beforeunload', handler);
        // clean it up, if the dirty state changes
        return () => unsavedChangesStore.deleteAllUnsavedChanges();
    }, []);

    const calculatePath = (type: string) => {
        return type.toLowerCase();
    };

    return <div className="insights">
        <div className="page-header">
            <NavigationMenu navigationMenuOptions={insightsNavigationMenuOptions} calculatePath={calculatePath} activeKey={logsStore.activeSubMenu} />
            <VersionButtonContainer isShowPartialLabels />
        </div>
        <Outlet />
    </div>;
});
